import React, { useEffect } from 'react';

import { YES, NO, FormRadioInput } from 'sellDirect/components/closingDash/form/FormRadioInput';
import { FormTextInput } from 'sellDirect/components/closingDash/form/FormTextInput';
import { IResetableFormRenderProps } from 'sellDirect/components/closingDash/ResetableForm';
import { text } from 'sellDirect/components/closingDash/content';
import { ClosingTasks } from 'sellDirect/helpers/closingTasks';
import { ServiceProvidersFormState } from 'sellDirect/components/closingDash/serviceProviders/ServiceProvidersForm';
interface IProps {
  shouldSeeAgentExperience: boolean;
  closingTasks: ClosingTasks;
  loading?: boolean;
  onCancel?: () => void;
  resetableForm: IResetableFormRenderProps;
}

/**
 * Service providers form - utilities section.
 *
 * component-test-check-ignore
 * storybook-check-ignore
 */
export const UtilitiesFormContent: React.FC<IProps> = ({
  shouldSeeAgentExperience,
  resetableForm,
}) => {
  const { onUpdate } = resetableForm;
  const formState: ServiceProvidersFormState = resetableForm?.formState;
  const { hasGas } = formState;

  useEffect(() => {
    if (hasGas === NO) {
      onUpdate('gas', undefined);
    }
  }, [hasGas, onUpdate]);

  return (
    <>
      <FormTextInput
        inputName="water"
        title={text.disclosuresPage.serviceAccounts.waterProvider(shouldSeeAgentExperience)}
        content={formState?.water}
        onUpdate={onUpdate}
        placeholder={`${shouldSeeAgentExperience ? 'Your client’s' : 'Your'} water provider`}
      />
      <FormTextInput
        inputName="electricity"
        title={text.disclosuresPage.serviceAccounts.electricalProvider(shouldSeeAgentExperience)}
        content={formState?.electricity}
        onUpdate={onUpdate}
        placeholder={`${shouldSeeAgentExperience ? 'Your client’s' : 'Your'} electricity provider`}
      />
      <FormRadioInput
        inputName="hasGas"
        title={text.disclosuresPage.serviceAccounts.hasGas(shouldSeeAgentExperience)}
        content={formState?.hasGas}
        onUpdate={onUpdate}
      />
      {formState?.hasGas === YES && (
        <FormTextInput
          inputName="gas"
          title={text.disclosuresPage.serviceAccounts.gasProvider(shouldSeeAgentExperience)}
          content={formState?.gas}
          onUpdate={onUpdate}
          placeholder={`${shouldSeeAgentExperience ? 'Your client’s' : 'Your'} gas provider`}
        />
      )}
    </>
  );
};
